<script setup lang="ts">
import { useOrderDetails } from "@shopware-pwa/composables-next";
import CommonLabel from "~/templates/components/CommonLabel.vue";
import { hasFailedPayment, orderArticleCount } from "~/utils/helper/shop/order";

const { order } = useOrderDetails();

const paymentCancelled = computed(() => hasFailedPayment(order.value));

const orderDate = computed(() =>
  order.value?.orderDate
    ? new Date(order.value?.orderDate ?? "").toLocaleDateString(
        (typeof navigator !== "undefined" && navigator.language) || "de-DE",
      )
    : "",
);
</script>

<template>
  <div v-if="order" class="grid grid-cols-2 gap-2 hyphens-auto text-sm xl:grid-cols-6" data-no-tracking>
    <div class="contents xl:order-last xl:flex xl:flex-col xl:items-start xl:gap-2">
      <CommonLabel class="font-medium" path="BWF/shop/account/orderDetails/articles" />
      {{ orderArticleCount(order) ?? "" }}
    </div>
    <div class="contents xl:flex xl:flex-col xl:items-start xl:gap-2">
      <CommonLabel class="font-medium" path="BWF/shop/account/orderDetails/dateOfOrder" />
      {{ orderDate }}
    </div>
    <div class="contents xl:flex xl:flex-col xl:items-start xl:gap-2">
      <CommonLabel class="font-medium" path="BWF/shop/account/orderDetails/status" />
      {{ order?.deliveries?.[0]?.stateMachineState?.name }}
    </div>
    <div class="contents xl:flex xl:flex-col xl:items-start xl:gap-2">
      <CommonLabel class="font-medium" path="BWF/shop/account/orderDetails/paymentStatus" />
      <span :class="{ 'text-signal-red': paymentCancelled }">{{
        order?.transactions?.[0]?.stateMachineState?.name
      }}</span>
    </div>
    <div class="contents xl:flex xl:flex-col xl:items-start xl:gap-2">
      <CommonLabel class="font-medium" path="BWF/shop/account/orderDetails/paymentMethod" />
      {{ order?.transactions?.[0]?.paymentMethod?.name }}
    </div>
    <div class="contents xl:flex xl:flex-col xl:items-start xl:gap-2">
      <CommonLabel class="font-medium" path="BWF/shop/account/orderDetails/shippingMethod" />
      {{ order?.deliveries?.[0]?.shippingMethod?.name }}
    </div>
  </div>
</template>
